import { configureStore } from "@reduxjs/toolkit";
import leadsReducer from "../features/Lead/leadsSlice";
import dashboardReducer from "../redux/Slices/dashboardSlice";
import { businessReducer } from "../redux/Slices/businessInfoSlice";
import { locationReducer } from "../redux/Slices/locationSlice";
import { contentLibraryReducer } from "../redux/Slices/contentLibrarySlice";
import { profileReducer } from "../redux/Slices/profileSettingsSlice";
import clientReducer from "../redux/Slices/clientSlice";
import clientListReducer from "../redux/Slices/clientSidebarSlice";
import todoReducer from "../redux/Slices/todoSlice";
import membershipOverviewReducer from "../redux/Slices/membershipOverviewSlice";
import { WorkoutReducer } from "../redux/Slices/workoutPreferenceSlice";
import coachSettingsSlice from "../redux/Slices/coachSettingsSlice";
import weightGoalSlice from "../redux/Slices/weightGoalSlice";
import clientCheckInReducer from "../redux/Slices/clientCheckInSlice";
import exercisesReducer from "../redux/Slices/toolboxExerciseSlice";
import progressReducer from "../redux/Slices/progressOverviewGraphSlice";
import clientInformationReducer from "../redux/Slices/clientInformationSlice";
import workoutReducer from "../redux/Slices/workoutSlice";
import leadOfferReducer from "../redux/Slices/leadOfferSlice";
import paymentReducer from "../redux/Slices/clientPaymentTabSlice";
import { WorkoutPlanReducer } from "../redux/Slices/workoutPlanSlice";
import { workoutPlanListReducer } from "../redux/Slices/workoutPlanListSlice";
import { WorkoutHistoryReducer } from "../redux/Slices/workoutHistorySlice";
import { workoutTemplateReducer } from "../redux/Slices/workoutTemplateSlice";
import { workoutTemplateByIdReducer } from "../redux/Slices/workoutTemplateListSlice";
import workoutPreferencePostReducer from "../redux/Slices/workoutPreferencePost";
import sendOfferEmailReducer from "../redux/Slices/sendOfferEmailSlice";
import notificationReducer from "../redux/Slices/notificationSlice";
import { recipesListReducer } from "../redux/Slices/recipesListSlice";
import { clientReminderReducer } from "../redux/Slices/clientReminderSlice";
import mealTagsSlice from "../redux/Slices/clientMealsTabsSlice";
import { recipesByIdReducer } from "../redux/Slices/recipesByIdSlice";
import { concernsListReducer } from "../redux/Slices/concernsListSlice";
import { mealPlanSummaryReducer } from "../redux/Slices/mealPlanSummarySlice";
import { messengerReducer } from "../redux/Slices/messengerSlice";
import { twilioReducer } from "../redux/Slices/twilioSlice";
import uploadFileMessengerSlice from "../redux/Slices/uploadFileMessengerSlice";
import onboardingReducer from "../redux/Slices/onboardingSlice";
import coachCardUpdateReducer from "../redux/Slices/coachCardUpdateSlice";
import coachOnboardReducer from "../redux/Slices/coachOnboardSlice";
import preferencesAllergiesReducer from "../redux/Slices/preferencesAllergiesSlice";
import mealPlanRecipesReducer from "../redux/Slices/mealPlanRecipesSlice";
import recipeImageReducer from "../redux/Slices/recipeImageSlice";
import addMealPlanReceipeReducer from "../redux/Slices/addMealPlanReceipeSlice";

export const store = configureStore({
  reducer: {
    leads: leadsReducer,
    business: businessReducer,
    location: locationReducer,
    contentLibrary: contentLibraryReducer,
    profile: profileReducer,
    clients: clientReducer,
    clientList: clientListReducer,
    dashboard: dashboardReducer,
    todo: todoReducer,
    membershipOverview: membershipOverviewReducer,
    getWorkoutPreference: WorkoutReducer,
    getWorkoutPlan: WorkoutPlanReducer,
    getWorkoutPlanList: workoutPlanListReducer,
    getWorkoutHistory: WorkoutHistoryReducer,
    getWorkoutTemplate: workoutTemplateReducer,
    getWorkoutTemplateById: workoutTemplateByIdReducer,
    coachSettings: coachSettingsSlice,
    weightGoal: weightGoalSlice,
    clientCheckIn: clientCheckInReducer,
    exercises: exercisesReducer,
    progress: progressReducer,
    clientInformation: clientInformationReducer,
    workouts: workoutReducer,
    leadOffer: leadOfferReducer,
    payment: paymentReducer,
    leadOfferEmail: sendOfferEmailReducer,
    clientReminder: clientReminderReducer,
    postWorkoutPreference: workoutPreferencePostReducer,
    notifications: notificationReducer,
    getRecipes: recipesListReducer,
    mealTags: mealTagsSlice,
    getRecipesById: recipesByIdReducer,
    getConcerns: concernsListReducer,
    getMealPlanSUmmary: mealPlanSummaryReducer,
    messenger: messengerReducer,
    twilio: twilioReducer,
    uploadFileMessenger: uploadFileMessengerSlice,
    onboarding: onboardingReducer,
    coachCardUpdate: coachCardUpdateReducer,
    coachOnboard: coachOnboardReducer,
    preferencesAllergies: preferencesAllergiesReducer,
    mealPlanRecipes: mealPlanRecipesReducer,
    recipeImages: recipeImageReducer,
    addMealPlanReceipe: addMealPlanReceipeReducer,
  },
});
